export const MobileIcon = (props: React.SVGProps<SVGSVGElement>) => {
  const width = props.width ? parseFloat(props.width.toString()) : 12.7;
  const innerWidth = Math.floor((11.2 / 12.7) * width);
  const height = props.width ? width * (17.5 / 12.7) : 17.5;
  const innerHeight = Math.floor((16 / 17.5) * height);
  const translate = 0.75 * (width / 12.7);
  const strokeWidth = Math.ceil(1.5 * (innerHeight / 16));
  const rx = Math.floor((4 / 3) * (1.5 * (innerHeight / 16)));
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      // {...props}
    >
      <g
        transform={`translate(${translate} ${translate})`}
        fill="none"
        stroke={props.stroke || "#313335"}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={strokeWidth}
        data-name="Group 126"
        className="stroke-jiwe-dark-blue dark:stroke-grey-light"
      >
        <rect
          data-name="Rectangle 361"
          width={innerWidth}
          height={innerHeight}
          rx={rx}
        />
        <path
          data-name="Line 157"
          d={`M${innerWidth / 2} ${innerHeight - 3.6}h.01`}
        />
      </g>
    </svg>
  );
};

export const ConsoleIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={32.575} height={16} {...props}>
    <path
      data-name="Icon ionic-logo-game-controller-a"
      d="M24.531 0H8.05A7.844 7.844 0 0 0 0 7.956 7.912 7.912 0 0 0 8.05 16h16.474a7.912 7.912 0 0 0 8.051-8.044A7.833 7.833 0 0 0 24.531 0ZM12.218 8.778a.4.4 0 0 1-.378.385H9.309v2.553a.413.413 0 0 1-.422.356H7.331a.336.336 0 0 1-.349-.327V9.163H4.429a.413.413 0 0 1-.356-.422V7.185a.336.336 0 0 1 .327-.351h2.582V4.305a.354.354 0 0 1 .335-.378h1.607a.4.4 0 0 1 .385.378v2.529h2.531a.354.354 0 0 1 .378.335Zm8.713.64a1.4 1.4 0 1 1 1.418-1.4 1.411 1.411 0 0 1-1.418 1.4Zm3.091 3.04a1.393 1.393 0 1 1 1.418-1.389 1.4 1.4 0 0 1-1.418 1.389Zm0-6.087a1.393 1.393 0 1 1 1.418-1.389 1.409 1.409 0 0 1-1.418 1.389Zm3.1 3.047a1.4 1.4 0 1 1 1.418-1.4 1.4 1.4 0 0 1-1.42 1.4Z"
      fill={props.fill || "#313335"}
      className="fill-jiwe-dark-blue dark:fill-grey-light"
    />
  </svg>
);

export const PCIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={19.6} height={18} {...props}>
    <g
      transform="translate(-1.223 -2)"
      fill="none"
      stroke={props.stroke || "#313335"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      className="stroke-jiwe-dark-blue dark:stroke-grey-light"
    >
      <rect
        data-name="Rectangle 360"
        width={17.6}
        height={12}
        rx={2}
        transform="translate(2.222 3)"
      />
      <path data-name="Line 155" d="M6.191 19h9" />
      <path data-name="Line 156" d="M11.022 15v4" />
    </g>
  </svg>
);
